var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-title",style:(_vm.styleObject)},[_c('div',{staticClass:"page-title__content"},[_vm._t("heading"),_vm._t("subheading")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }